import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'

import { dateToString } from 'modules/core/lib/dates'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

export const sendReportFile = async function ({
  startOn,
  endOn,
  employeeSelection,
  leaveTypeIds,
  timeFormat,
  timePeriod,
  fileType,
  fileFormat,
}: {
  startOn: moment.Moment
  endOn: moment.Moment
  employeeSelection: EmployeeSelectorV2MultiSelectState
  leaveTypeIds: number[]
  timeFormat: string
  timePeriod: string
  fileType: string
  fileFormat: string
}): Promise<boolean> {
  const params = omitBy(
    {
      start_on: dateToString(startOn, 'backend'),
      end_on: dateToString(endOn, 'backend'),
      employee_selection: employeeSelection,
      leave_type_ids: leaveTypeIds,
      time_format: timeFormat,
      time_period: timePeriod,
      type: fileType,
      file_format: fileFormat,
    },
    isNil
  )

  const sendExportLocation = '/attendance/exports'
  const api = ApiClient()
  let response = false

  try {
    const payload = await api.post(sendExportLocation, params)
    response = payload.result
  } catch (_error) {}

  return response
}
